import { createReducer, on } from '@ngrx/store';
import { setPermissions, clearPermissions } from '../actions/permission.actions';
import { initialPermissionState } from '../models/permissions.model';

export const permissionReducer = createReducer(
    initialPermissionState,
    on(setPermissions, (state, { permissions }) => ({ ...state, permissions })),
    on(clearPermissions, () => ({ ...initialPermissionState }))
);
